"use client";
import React from "react";
import styled from "styled-components";

const ButtonWrapper = styled.div`
  position: relative;
  margin-top: 10px;
  width: 56px;

  @media (max-width: 991px) {
    white-space: initial;
  }
`;

const Button = styled.div`
  border-radius: 8px;
  width: 100%;
  border: none;
  color: #1fbdcb;
  font-size: 14px;
  font-weight: 600;

  @media (max-width: 991px) {
    white-space: initial;
  }
`;

export default function StartButton({ text }) {
  return (
    <ButtonWrapper>
      <Button>{text}</Button>
    </ButtonWrapper>
  );
}
